require('./src/styles/global.min.css')
